<woa-modal-page-layout [title]="'woa.heading.3ds.title'" [customGeometry]="{disableSwipe: true, height: '100%'}">
    <div #threeDsHolder class="threeDs-holder"></div>
</woa-modal-page-layout>
